import { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import Modal from './components/Modal';
import { apiEndpoint } from './constants/api';
import { ProjectSearchTable } from './components/ProjectSearchTable';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: {...state.user.currentEmployer}
}), {});
function ProjectSearch({ user, employer }) {
  const [isOpened, setIsOpened] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [activeProject, setActiveProject] = useState({});
  const [query, setQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const timeout = useRef();

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const findProjectData = async ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setQuery(value);
    timeout.current = setTimeout(() => loadProjectData(value), 700);
  };

  const loadProjectData = async (q) => {
    const { data } = await axios.post(apiEndpoint('/search/projects'), { 
      q,
      employer: employer.value 
    });
    setProjectData(data);
    setSearching(false);
  };

  const saveProjectData = async () => {
    const { data } = await axios.post(apiEndpoint('/employer/projects'), { 
      project: activeProject,
      employer: employer.value
    });
    loadProjectData();
    closeModal();
  }

  const createNewProject = () => {
    setActiveProject({});
    setIsOpened(true);
  }

  const updateActiveProject = (key, { target: { value } }) => {
    setActiveProject({ ...activeProject, [key]: value });
  }

  const closeModal = () => {
    setIsOpened(false);
  }

  useEffect(() => {
    loadProjectData();
  }, [employer]);


  return (
    <>
    <Helmet>
      <title>Project Search | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div className="flex flex-row justify-between content-start mb-3">
                <h1 className="text-2xl">Projects</h1>
                <button
                  type="button"
                  onClick={createNewProject}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                    + New Project
                </button>
              </div>
              <div>
                <div className="pb-2">
                  <form onSubmit={onSubmit}>
                    <label
                      htmlFor="project-search"
                      className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Search
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5 text-gray-500 dark:text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                      <input
                        onChange={findProjectData}
                        type="search"
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search Projects..."
                        required
                      />
                    </div>
                  </form>
                </div>
                {(projectData && projectData.length) ? 
                (
                  <ProjectSearchTable
                    projectData={projectData}
                    searching={searching}
                  />
                ) : <></>
                }
                {(projectData && !projectData.length) ? 
                (
                  <button onClick={createNewProject} className="w-full text-center bg-blue-50 rounded-lg border-2 py-3">
                  <div>
                  <div className="text-xl hover:text-underline">Create your First Project</div>
                  <div>Projects are used to categorize job postings</div>
                  </div>
                  </button>

                ) : <></>
                }
                {(!projectData) ? 
                (
                  <div className="w-full">
                    <div className="mx-auto">Loading Projects...</div>
                  </div>
                ) : <></>
                }
              </div>
              {/* /End replace */}
            </div>
            <Modal
              title="Create Project"
              isOpened={isOpened}
              onClose={closeModal}
            >
              <form className="w-full">
                <div className="text-lg text-left mb-5">
                  Create New Project
                </div>
                <div className="my-5">
                  <label
                      htmlFor="project-name"
                      className="mb-2 text-lg font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Project Name
                    </label>
                    <div className="relative">
                      <input
                        type="search"
                        onChange={(d) => updateActiveProject('name', d)}
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Project Name"
                        required
                      />
                    </div>
                </div>
                <div>
                  <div className="text-lg text-left">Project Types</div>
                  <div className="flex my-5">
                  <div className="w-1/2">
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-1" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-1" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Scripted</label>
                  </div>
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-2" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-2" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Unscripted</label>
                  </div>
                  </div>
                  <div className="w-1/2">
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-3" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-3" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Feature Film</label>
                  </div>
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-4" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-4" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Documentary</label>
                  </div>
                  </div>
                  <div className="w-1/2">
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-5" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-5" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Sports</label>
                  </div>
                  <div className="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
                      <input id="project-types-6" type="checkbox" value="" name="project-types" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="project-types-6" className="w-full py-4 ml-2 text-lg font-medium text-gray-900 dark:text-gray-300">Animation</label>
                  </div>
                  </div>
                  </div>
                </div>
                <div className="my-2">
                  <button
                    type="button"
                    onClick={saveProjectData}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Create Project
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-lg font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(ProjectSearch)